<ion-header>
  <div>
    <ion-title size="large">My Scripts</ion-title>
  </div>
  <div class="script-actions">
    <app-simple-button (click)="refreshScripts()" size="large" icon="sync-outline" />
    <app-simple-button (click)="addScript(true)" size="large" color="tint" icon="add-outline" />
  </div>
</ion-header>

<ion-content>
  <ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
    <ion-refresher-content></ion-refresher-content>
  </ion-refresher>
  <div class="content-wrapper">
    @if (isLoggedIn() && scripts().length > 0) {
      <app-add-script-card #addScriptCard />
      <div class="scripts" [ngClass]="addScriptCard.visible() ? 'mt-24' : 'mt-0'">
        @for (script of scripts(); track $index) {
          <app-script-card [script]="script" />
        }
      </div>
    } @else {
      <div class="empty-state">
        <img src="assets/images/empty-script-wallet.svg">
        <div class="title">Add your first eScript to get started!</div>
        <div class="subtitle">All your scripts in one, safe place.</div>
        <app-button (click)="addScript()" label="Add eScript" />
      </div>
    }
  </div>
</ion-content>